<div class="m-333">
  <button mat-raised-button class="mb-05" color="primary" (click)="openPopUp({}, true)" *ngIf="addBtnName">
    {{addBtnName|translate}} </button>
</div>
<mat-card class="p-0" [@animate]="{value:'*',params:{y:'50px',delay:'300ms'}}">
  <mat-card-content class="p-0">
    <div class="table-container mat-elevation-z8 p-0 "
      [ngStyle]="{'overflow-x':  showHorizontalScroll ? 'scroll;' : ''}"
      [@animate]="{value:'*',params:{y:'50px',delay:'300ms'}}">
      <div class="grid-wrapper-table">
        <table mat-table [dataSource]="items" matSort [fixedLayout]="fiksnaSirinaKolona">
          <ng-container *ngIf="cb" matColumnDef="cb">
            <th mat-header-cell *matHeaderCellDef>
            </th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox [color]="row.jeSekcija ? 'accent' : 'primary'"
                [ngClass]="{ 'sekcija-border': row.jeSekcija }"
                (change)="checkBtnClick($event.checked, row)"></mat-checkbox>
            </td>
          </ng-container>

          <ng-container *ngIf="!dugmiciSaDesneStrane" matColumnDef="actions">
            <th class="actionscol" mat-header-cell *matHeaderCellDef>
            </th>
            <td class="actionscol" mat-cell *matCellDef="let row">
              <div fxLayout="row">
                <button data-testid="btnIzmeni" *ngIf="editButton" matTooltip="{{'general.edit'|translate}}"
                  [matTooltipPosition]="'after'" mat-icon-button mat-sm-button color="primary"
                  [ngStyle]="row.jeSekcija && {'color': 'white'}" class="mr-05" (click)="openPopUp(row)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button *ngIf="deleteButton" matTooltip="{{'general.delete'|translate}}" mat-icon-button mat-sm-button
                  [matTooltipPosition]="'after'" color="warn" [ngStyle]="row.jeSekcija && {'color': 'white'}"
                  class="mr-05" (click)="deleteItem(row)">
                  <mat-icon>delete</mat-icon>
                </button>
                <button *ngIf="viewButton" matTooltip="{{'general.view'|translate}}" mat-icon-button mat-sm-button
                  [matTooltipPosition]="'after'" color="primary" [ngStyle]="row.jeSekcija && {'color': 'white'}"
                  class="mr-05" (click)="viewItem(row)">
                  <mat-icon>visibility</mat-icon>
                </button>
                <button *ngIf="dugmeDodaj" color="primary" [ngStyle]="row.jeSekcija && {'color': 'white'}"
                  mat-raised-button [matTooltipPosition]="'after'"
                  (click)="dodajClicked($event.currentTarget, row)">{{translatePrefix + 'dodaj' | translate}}</button>
                <ng-container *ngFor="let button of extraButtons">
                  <!-- hasRole(button.btnAction, row) && -->
                  <button *ngIf="hasRole(button.btnAction, row) && !button.hidden(row)" [disabled]="button.disable(row)"
                    matTooltip="{{button.tooltip | translate}}" [matTooltipPosition]="'after'" mat-icon-button
                    mat-sm-button [color]="button.color" [ngStyle]="row.jeSekcija && {'color': 'white'}" class="mr-05"
                    (click)="extraBtnClick(row, button.btnAction)">
                    <mat-icon>{{button.icon}}</mat-icon>
                  </button>
                </ng-container>
              </div>
            </td>
            <td mat-footer-cell *matFooterCellDef style="text-align: center;">
              <button matTooltip="{{'general.add' | translate}}" class="mr-1" mat-icon-button mat-sm-button
                color="primary" (click)="addItem()" [disabled]="this.addForm.invalid">
                <mat-icon>add_circle</mat-icon>
              </button>
            </td>
          </ng-container>

          <ng-container *ngIf="showNumberColumn" matColumnDef="numberColumn">
            <th class="rownumcol" mat-header-cell *matHeaderCellDef>
              {{ showNumberColumnHeader ? ('general.numberColumn' | translate) : '' }}
            </th>
            <td class="rownumcol" mat-cell *matCellDef="let row; let i=index">
              {{(numPage - 1) * pageSize + i+1}}
            </td>
          </ng-container>

          <ng-container *ngFor="let column of columnDefinition; let i = index" matColumnDef="{{column.columnName}}"
            [ngSwitch]="column.columType">
            <span>
              <th style="padding-left: 15px !important;" class="w-75 table-container-justify-content" mat-header-cell
                [hidden]="column.hide == true" *matHeaderCellDef
                [mat-sort-header]=" column.isSortable ? column.columnName : null "
                [disabled]="column.isSortable ? false : true " disableClear
                [ngStyle]="column.isVisible == false && {'color' : 'transparent'}">
                {{column.hideHeader !== true ? column.ignoreTranslatePrefix ? column.columnName :
                ((translatePrefix+column.columnName)|translate) : ''}}</th>
              <td mat-cell class={{column.class}} *matCellDef="let row" [hidden]="column.hide == true"
                attr.data-label="{{(translatePrefix+column.columnName) | translate}}">

                <div *ngIf="column.columnType!='lista'"
                  [matTooltip]="(!!column.textLength && row[column?.columnName]?.length > column.textLength) ? row[column.columnName] : ''"
                  matTooltipClass="(!!column.textLength && row[column?.columnName]?.length > column.textLength) ? tooltip : ''"
                  [class.jedanRed]="!!column.textLength && row[column?.columnName]?.length > column.textLength"
                  [ngStyle]="{
                    'text-decoration': !!column.isDeactivated &&
                      (row.statusId == statusSvojstvaEnum.Deaktivirano ||
                       row.statusNaTipuId == statusSvojstvaEnum.Deaktivirano ||
                       row.statusId == statusElementaPorukeEnum.Deaktivirano ||
                       row.statusNaPojmuId == statusSvojstvaEnum.Deaktivirano) ? 'line-through' : null,

                    'background-color': row.jeSekcija ? getColorByLevel(row.nivo) : null,
                    'color': row.jeSekcija ? 'white' : null,
                    'padding-left.px': column.paddingByLevel ?
                      row[column.paddingColumnName] * 10 : null
                  }">
                  <ng-container *ngIf="!!!column.formatToText && !!!column.isDeprecated">
                    {{
                    column.displayText ? ((column.isJsonColumn ? parseJsonColumn(row, column) != null :
                    row[column.columnName] != null) ?
                    (column.columnType=='date' ? ((column.isJsonColumn ? parseJsonColumn(row, column) :
                    row[column.columnName]) | date:'dd.MM.yyy') :
                    (column.columnType=='datetime' ? ((column.isJsonColumn ? parseJsonColumn(row, column) :
                    row[column.columnName]) | date:'dd.MM.yyy HH:mm:ss') :
                    (!!column.textLength && (column.isJsonColumn ? parseJsonColumn(row, column)?.length :
                    row[column?.columnName]?.length) > column.textLength ?
                    ((column.isJsonColumn ? parseJsonColumn(row, column) : row[column.columnName]) |
                    slice:0:column.textLength)+'...' :
                    (column.isJsonColumn ? parseJsonColumn(row, column) : row[column.columnName])) ))
                    :
                    '/') : ''
                    }}
                  </ng-container>
                  <ng-container *ngIf="!!column.formatToText && !!!column.isDeprecated">
                    {{ column.formatItem(row[column.columnName]) }}
                  </ng-container>
                </div>
                <mat-checkbox *ngIf="column.columnType=='checkbox'" [checked]="row[column.columnName]"
                  [ngStyle]="row.jeSekcija && {'color': 'white'}" [disabled]="true">
                </mat-checkbox>
                <mat-chip *ngIf="column.columnType=='chip'" selected="true" mat-sm-chip selected
                  [class]="chipStyleStatusEnum[row[column.idColumnName]]">{{ row[column.columnName] }}
                </mat-chip>
                <div *ngIf="column.columnType=='tooltip'" [matTooltip]="row[column.columnName] || ''"
                  matTooltipClass="tooltip">
                  {{ row[column.columnName] != '' ? subString(row[column.columnName],0,40) : '' }}
                </div>

                <button
                  *ngIf="column.columnType=='button' && row[column.idColumnName] === this.statusPrijaveEnum.PrijavaZavrsena"
                  matTooltip="{{translatePrefix+column.columnName|translate}}" mat-icon-button mat-sm-button
                  color="primary" class="mr-1" (click)="download(row)">
                  <mat-icon>description</mat-icon>
                </button>
              </td>
              <td>
              </td>
              <td mat-footer-cell *matFooterCellDef style="text-align: left;">
                <div style="height: 1.25em;">
                  <div
                    *ngIf="this.addForm.controls[column.columnName].dirty || this.addForm.controls[column.columnName].touched">
                    <mat-error style="font-size: smaller;"
                      *ngIf="this.addForm.controls[column.columnName].errors?.required">
                      {{'general.fieldRequired' | translate}}</mat-error>
                    <mat-error style="font-size: smaller;"
                      *ngIf="this.addForm.controls[column.columnName].errors?.maxlength">{{('general.maximalLength' |
                      translate) +
                      this.addForm.controls[column.columnName].errors.maxlength.requiredLength}}</mat-error>
                  </div>
                </div>
              </td>
            </span>
          </ng-container>
          <ng-container *ngIf="dugmiciSaDesneStrane" matColumnDef="actionsDesno">
            <th mat-header-cell *matHeaderCellDef>
            </th>
            <td mat-cell *matCellDef="let row">
              <div fxLayout="row" fxLayoutAlign="end center">
                <button data-testid="btnIzmeni" *ngIf="editButton" matTooltip="{{'general.edit'|translate}}"
                  mat-icon-button mat-sm-button color="primary" class="mr-1" (click)="openPopUp(row)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button *ngIf="deleteButton" matTooltip="{{'general.delete'|translate}}" mat-icon-button mat-sm-button
                  color="warn" class="mr-1" (click)="deleteItem(row)">
                  <mat-icon>delete</mat-icon>
                </button>
                <button *ngIf="viewButton" matTooltip="{{'general.view'|translate}}" mat-icon-button mat-sm-button
                  color="primary" class="mr-1" (click)="viewItem(row)">
                  <mat-icon>visibility</mat-icon>
                </button>
                <ng-container *ngFor="let button of extraButtons">
                  <button *ngIf="hasRole(button.btnAction, row) && !button.hidden(row)" [disabled]="button.disable(row)"
                    matTooltip="{{button.tooltip | translate}}" mat-icon-button mat-sm-button [color]="button.color"
                    class="mr-1" (click)="extraBtnClick(row, button.btnAction)">
                    <mat-icon>{{button.icon}}</mat-icon>
                  </button>
                </ng-container>
              </div>
            </td>
            <td mat-footer-cell *matFooterCellDef style="text-align: center;">
              <button matTooltip="{{'general.add' | translate}}" class="mr-1" mat-icon-button mat-sm-button
                color="primary" (click)="addItem()" [disabled]="this.addForm.invalid">
                <mat-icon>add_circle</mat-icon>
              </button>
            </td>
          </ng-container>
          <ng-container *ngIf="this.inputFooter">
            <tr mat-header-row *matHeaderRowDef="columnNames;"></tr>
            <tr mat-row *matRowDef="let row; columns: columnNames;"
              [ngStyle]="row.jeSekcija ? {'background-color' : getColorByLevel(row.nivo), 'color': 'white'} : {}">
            <tr mat-footer-row *matFooterRowDef="columnNames; sticky: true"></tr>
          </ng-container>
          <ng-container *ngIf="!this.inputFooter">
            <tr mat-header-row *matHeaderRowDef="columnNames;"></tr>
            <tr mat-row *matRowDef="let row; columns: columnNames;" class="izabraniRed"
              [ngStyle]="row.jeSekcija ? {'background-color' : getColorByLevel(row.nivo), 'color': 'white'} : {}"
              [class.highlight-row]="row.id === highlightedRowId"></tr>
          </ng-container>

        </table>
      </div>
      <div *ngIf="items && items.length==0" class="no-records">
        {{'general.noResults' | translate}}
      </div>
      <div *ngIf="showLoader">
        <mat-progress-bar mode="indeterminate" color="warn" class="session-progress "></mat-progress-bar>
      </div>
      <mat-paginator *ngIf="showPaginator" (page)="setPage($event)" [pageIndex]="numPage" [length]="totalElements"
        [pageSizeOptions]="[5, 10, 25]" [pageSize]="pageSize" showFirstLastButtons>
      </mat-paginator>
    </div>
  </mat-card-content>
</mat-card>